const getStorageKey = (vehicleType) => (vehicleType === 'N' ? `VTP_AOZ_NC` : `VTP_AOZ_UC`);
export function getSessionStorageOrDefault(vehicleType) {
    if (typeof window !== 'undefined') {
        const key = getStorageKey(vehicleType);
        const stored = sessionStorage.getItem(key);
        return stored ? JSON.parse(stored) : {};
    }
    return [];
}
export function getAozProductsFromSession(vehicle) {
    if (vehicle) {
        const sessionStorage = getSessionStorageOrDefault(vehicle.type);
        if (sessionStorage[vehicle === null || vehicle === void 0 ? void 0 : vehicle.id]) {
            return sessionStorage[vehicle.id];
        }
    }
    return [];
}
